// @ts-nocheck
import React, { Component } from 'react';

import axios from 'config/api';

import TextField, { Input } from '@material/react-text-field';
import Button from '@material/react-button';
import login_bg from 'assets/img/login_bg.png';
import logo from 'assets/img/login-logo.png';
import { API_URL } from 'config/constants';
import { errorToast } from 'utils/toastHandler';
import { Link } from 'react-router-dom';
import { EmailIcon } from 'assets/icons';
import { common } from 'assets/colors/colors';
// import InputField from 'components/atoms/InputField';

class ForgotPassword extends Component {
  state = {
    email: '',
    errors: '',
    success: false,
    loading: false,
  };

  handleOnChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      success: false,
    });
  };

  validateEmail = () => {
    const { email } = this.state;
    const errors = {};
    const emailRegex = /^\S+@\S+\.\S+$/;
    if (!email) errors.email = 'required';
    if (email && emailRegex.test(email) === false)
      errors.email = 'Invalid email';
    return errors;
  };

  handlePostRequest = () => {
    if (Object.keys(this.state.errors).length === 0) {
      const { email } = this.state;
      axios
        .get(
          `${API_URL}/user/forget-password/?email=${encodeURIComponent(email)}`,
        )
        .then((res) => {
          this.setState({ success: true, loading: false });
        })
        .catch((e) => {
          this.setState({ success: false, loading: false });
          errorToast(e.response.data.error);
        });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateEmail();
    this.setState(
      {
        errors,
        loading: Object.keys(errors).length === 0,
      },
      this.handlePostRequest,
    );
  };

  render() {
    const { email, errors, loading, success } = this.state;
    return (
      <div
        className="authentication parallax-container"
        style={{ backgroundImage: `url(${login_bg})` }}
      >
        <div className="container">
          <div className="card auth_form">
            <div className="login-logo">
              <img className="logo" src={logo} alt="" />
            </div>

            <div className="body">
              <div className="login-header">
                <h5>Forgot Password</h5>

                {success && !loading && (
                  <span
                    style={{
                      background: '#4CAF50',
                      borderRadius: 4,
                      fontWeight: 400,
                      fontSize: 14,
                      color: '#fff',
                      padding: 8,
                      display: 'block',
                      marginBottom: 20,
                      marginTop: 10,
                    }}
                  >
                    Email reset link has been successfully sent to provided
                    email address. Please check your email.
                  </span>
                )}

                {loading && (
                  <span
                    style={{
                      color: '#fff',
                    }}
                  >
                    Loading... please wait
                  </span>
                )}
              </div>
              <form onSubmit={this.onSubmit}>
                <div className="form-group">
                  <TextField
                    outlined
                    leadingIcon={
                      <EmailIcon
                        sx={{
                          color: `${common.icon} !important`,
                          fontSize: '18px',
                          marginBottom: '4px',
                        }}
                      />
                    }
                    label="Email*"
                  >
                    <Input
                      id="email"
                      name="email"
                      value={email || ''}
                      onChange={this.handleOnChange}
                      type="email"
                    />
                  </TextField>
                  {errors.email && (
                    <span className="error">{errors.email}</span>
                  )}
                </div>
                <div className="form-group ">
                  <Button raised type="submit" disabled={loading}>
                    Submit
                  </Button>
                </div>
                {success && !loading && (
                  <div className="form-group text-center">
                    <p>
                      Go Back to{' '}
                      <Link
                        style={{ color: '#fff', textDecoration: 'underline' }}
                        to="/login"
                      >
                        Login
                      </Link>{' '}
                      Page.
                    </p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ForgotPassword;
